import { Popover } from 'bootstrap';

const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
popoverTriggerList.map((popoverTriggerEl) => new Popover(popoverTriggerEl));
